import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { WindowToken } from "@app/util/window.token";

@Component({
    template: require('./registrationDialogStopProcess.html')
})
export class RegistrationStopProcessDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<RegistrationStopProcessDialog>) public dialogRef: MatDialogRef<RegistrationStopProcessDialog>,
                @Inject(WindowToken) public window) {}

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }
    openUrl(url) {
        this.window.open(url, '_blank');
    }
}
